module.exports = __webpack_public_path__ + "img/quan_bg.d59a4878.png";